import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=1a9a9de2&scoped=true&"
import script from "./BookingDetail.vue?vue&type=script&lang=js&"
export * from "./BookingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a9de2",
  null
  
)

export default component.exports